<template>
  <div class="">
    <b-overlay :show="showoverlay" rounded="sm" class="col-md-12">
      <!-- Filters and Action Buttons -->
      <div class="clearfix row py-2 mb-2 no-margin align-items-end">
        <div class="col-md-3">
          <b-form-group label="From Date" label-for="from_date" class="mb-0">
            <b-input-group class="mb-0">
              <b-form-input id="from_date" name="from_date" v-model="from_date" type="text" placeholder="YYYY-MM-DD" autocomplete="off" />
              <b-input-group-append class="mb-0">
                <b-form-datepicker class="mb-0" id="dp_from_date" button-only right locale="en-US" v-model="from_date" />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>

        <div class="col-md-3">
          <b-form-group label="To Date" label-for="to_date" class="mb-0">
            <b-input-group class="mb-0">
              <b-form-input id="to_date" name="to_date" v-model="to_date" type="text" placeholder="YYYY-MM-DD" autocomplete="off" />
              <b-input-group-append class="mb-0">
                <b-form-datepicker class="mb-0" id="dp_to_date" button-only right locale="en-US" v-model="to_date" />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>

        <div class="col-md-6 no-margin p-0">
          <div class="row d-flex justify-content-end no-margin">
            <b-button variant="secondary" class="d-flex justify-content-end m-1" @click="resetView()">Reset Selection</b-button>
            <b-button variant="primary" class="d-flex justify-content-end m-1 btn-warning" @click="previewOrDownload(0)">Preview Report</b-button>
            <b-button variant="primary" class="d-flex justify-content-end m-1 btn-warning" @click="previewOrDownload(1)">Download Report (Excel)</b-button>
          </div>
        </div>
      </div>

      <!-- Preview Mode -->
      <div class="mt-3" v-if="is_preview">
        <div class="card-body container px-0">
          <div class="row justify-content-center no-margin">
            <div class="col-sm-12 px-0">
              <b-overlay :show="showoverlay_list" rounded="sm">
                <div class="table-responsive">
                  <table class="table table-bordered table-striped table-hover dataTable">
                    <thead>
                      <tr class="table-head">
                        <th>Employee Code</th>
                        <th>Name</th>
                        <th>Department</th>
                        <th>Job Position</th>
                        <th>Compensatory Off Day Date</th>
                        <th>Original Off-Day Date</th>
                        <th>Assigned Shift</th>
                        <th>Reason</th>
                        <th>Status</th>
                        <th>Assigned By</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in preview_data" :key="index">
                        <td>{{ item.employee_code }}</td>
                        <td>{{ item.employee_name }}</td>
                        <td>{{ item.department }}</td>
                        <td>{{ item.jobposition }}</td>
                        <td>{{ item.off_date }}</td>
                        <td>{{ item.work_date }}</td>
                        <td>{{ item.shift_name }}</td>
                        <td>{{ item.reason }}</td>
                        <td>
                          <span class="leave-status" v-if="item.status == 'Approved'"><i class="far fa-dot-circle mr-1 text-success"></i>{{item.status}}</span>
                          <span class="leave-status" v-else-if="item.status == 'Applied' || item.status == 'Pending'"><i class="far fa-dot-circle mr-1 text-primary"></i>{{item.status}}</span>
                          <span class="leave-status" v-else-if="item.status == 'Declined'"><i class="far fa-dot-circle mr-1 text-danger"></i>{{item.status}}</span>
                          <span v-else>{{item.status}}</span>
                        </td>
                        <td>{{ item.updated_by }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div v-if="preview_data.length === 0" class="list-no-data text-center py-4">No records found.</div>
              </b-overlay>
            </div>
          </div>
        </div>
      </div>

      <!-- Selection / Grid Setup Mode -->
      <div v-else class="row" id="assignment">
        <div class="col-12 mt-3">
          <b-badge class="d-inline mb-3" variant="info">Selected Employees: {{ employee_ids.length }}</b-badge>
          <div class="card border-0 no-shadow">
            <common-list 
              :checkbox="1" 
              :is_action="0" 
              :appended_column="[]" 
              :key="list_key"
              :company_options="company_options" 
              :employees="custom_list" 
              :all_employee="'no'"
              :default_column="default_column" 
              :primary_key="'employee_id'" 
              v-on:childToParent="listReturn" />
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      from_date: moment().startOf('month').format('YYYY-MM-DD'),
      to_date: moment().endOf('month').format('YYYY-MM-DD'),
      checkbox: 1,
      list_key: 0,
      custom_list: [],
      default_column: ['name', 'employee_code', 'jobposition', 'branch', 'department'],
      primary_key: 'employee_id',
      company_options: [],
      employee_ids: [],
      preview_data: [],
      is_preview: false,
      showoverlay: false,
      showoverlay_list: false,
    }
  },
  methods: {
    resetView() {
      this.is_preview = false;
      this.preview_data = [];
      this.employee_ids = [];
      this.list_key++;
      this.getEmployeesList();
    },

    listReturn(data) {
      this.employee_ids = data.selected;
    },

    getEmployeesList() {
      this.showoverlay = true;
      axios.get(this.$api_url + '/leave-attendance/employees/list', { 
        params: { all: 1, fields: 'department,jobposition' } 
      }).then(response => {
        this.custom_list = response.data.employee_data;
        this.company_options = response.data.options;
        this.list_key++;
        this.showoverlay = false;
      }).catch(error => {
        this.showoverlay = false;
        this.serverError(error);
      });
    },

    previewOrDownload(flg) {
      if (!this.checkNet()) return false;

      let currentObj = this;
      if (flg === 0) {
        this.$bvToast.toast('Generating the preview, please hold tight.', {
          title: `Info`,
          variant: 'info',
          solid: true
        });
      } else if (flg === 1) {
        this.$bvToast.toast('We are downloading the report, this may take a while.', {
          title: `Info`,
          variant: 'info',
          solid: true
        });
      }

      this.showoverlay = true;
      this.showoverlay_list = true;

      let config = {};
      if (flg === 1) {
        config = {
          responseType: 'blob'
        };
      }
      let formData = new FormData();
      formData.append('from_date', this.from_date);
      formData.append('to_date', this.to_date);
      formData.append('employee_ids', JSON.stringify(this.employee_ids));
      formData.append('is_export', flg);

      axios.post(this.$api_url + '/leave-attendance/compensatory-leave-report', formData, config).then(response => {
        this.showoverlay = false;
        this.showoverlay_list = false;

        if (flg === 0) {
          this.preview_data = response.data;
          this.is_preview = true;
        } else if (flg === 1) {
          this.global_download_file_content(response);
        }
      }).catch(error => {
        this.showoverlay = false;
        this.showoverlay_list = false;
        currentObj.serverError(error);
      });
    }
  },
  created() {
    this.getEmployeesList();
  }
}
</script>

<style scoped>
.dataTable {
  font-size: 14px;
}
.table-head th {
  background-color: #f8f9fa;
  font-weight: 600;
  text-align: center;
}
</style>
